export const BASE_URL = "https://gis.ntpmis.gov.np/api/";
export const EMBED_URL = "https://gis.ntpmis.gov.np/#/embed/";
// export const BASE_URL = "https://ntccgis.perigee.com.np/api/";
// export const EMBED_URL = "https://ntccgis.perigee.com.np/#/embed/";
//export const BASE_URL = "http://127.0.0.1:8000/api/";
//export const EMBED_URL = "http://127.0.0.1:8000/#/embed/";
